<template>
  <div>
    <v-app-bar color="primary" app fixed>
      <v-icon @click="back" color="white">mdi-arrow-left</v-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title style="color:white; margin-right:20px;">{{title}}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <router-view style="margin-top:65px"></router-view>
    <v-bottom-navigation
      :value="value"
      background-color="primary"
      color="white"
      app
      fixed
      v-if="ticketId != null && ticketId != 0"
    >
      <v-btn :to="{path: 'addUpdateDemmands'}">
        <span style="font-size:16px">Dados</span>
      </v-btn>

      <v-btn :to="{path: 'interactions'}">
        <span style="font-size:16px">Interações</span>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>
<script>
  export default {
    data: () => ({ 
      value: 0,
      ticketId: null,
      loginData: null,
      title: ""  
    }),

    methods: {
      back(){
        this.$router.push('listDemmands');
      }
    },

    created(){
      this.loginData = JSON.parse(localStorage.getItem("loginData"));
      
      let canDemands = this.loginData.permissionAndMenu.find(permission => {
        return permission.menuId == 27
      });

      if(!(canDemands != null || this.loginData.userData.userType == 2))
        this.$router.push('menu');
      else{
        if(this.$route.name == "Interactions")
          this.value = 1;
        else
          this.value = 0;

        this.ticketId = localStorage.getItem("ticketId");
        
        let label = this.loginData.labels.find((lbl) => {
          return lbl.typeLabel == 1
        });
        
        this.title = this.ticketId != null && this.ticketId != 0 ? "Detalhes" : `Novo ${label.name}`; 
      }
    },

    beforeDestroy(){
        localStorage.removeItem("ticketId");
    }
  }
</script>
<style>
 /* iphone X , XS, 11 Pro, 12 Mini */
@media only screen and (min-width: 375px) and (max-height: 812px) and (-webkit-device-pixel-ratio: 3) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
}

/* iphone 12, 12 Pro */
@media only screen and (min-width: 390px) and (max-height: 844px) and (-webkit-device-pixel-ratio: 3) {
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
}

/* iphone XR, 11 */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 2) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
}
    
/* iphone XS Max, 11 Pro Max */
@media only screen and (min-width : 414px) and (max-height : 896px) and (-webkit-device-pixel-ratio : 3) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
}

/* iphone 12 Pro Max */
@media only screen and (min-width : 428px) and (max-height : 926px) and (-webkit-device-pixel-ratio : 3) { 
  .v-item-group.v-bottom-navigation--fixed {
    height: 80px !important;
  }
}
</style>